import { AfterViewInit, Component, ElementRef, inject, input, OnDestroy, viewChild } from '@angular/core';
import { BottomSheetLevel } from 'src/app/interfaces/mat.interface';
import { MatBottomSheetService } from 'src/app/services/mat-bottom-sheet.service';

@Component({
  selector: 'app-drag-handle',
  standalone: true,
  templateUrl: './drag-handle.component.html',
  styleUrls: ['./drag-handle.component.scss'],
  host: {
    '[style.position]': 'cssPosition() || "sticky"',
    '[style.top]': '"0"',
    '[style.left]': '"0"',
    '[style.z-index]': '"1000"',
    '[style.display]': '"block"',
    '[style.width]': '"100%"',
    '[style.height]': '"fit-content"',
  }
})
export class DragHandleComponent implements AfterViewInit, OnDestroy {
  public dragHandleRef = viewChild.required<ElementRef>('dragHandleRef');
  
  public cssPosition = input<string>('sticky');
  
  private _matBottomSheetService = inject(MatBottomSheetService);

  ngAfterViewInit(): void {
    if (!this.dragHandleRef()) return;
    this._matBottomSheetService.bottomSheetCurrentLevel = BottomSheetLevel.EXPANDED;
    this._matBottomSheetService.changeLevelBottomSheetOnSwipeDown(this.dragHandleRef());
  }
  
  ngOnDestroy(): void {
    if (!this.dragHandleRef()) return;
    this._matBottomSheetService.destroyBottomSheetOnSwipeDown(this.dragHandleRef());
  }
}
